import { X } from 'lucide-react';
import {
  settlementModalBodyClass,
  settlementModalBodyCompactClass,
  settlementModalBodyFillClass,
  settlementModalHeaderClass,
  settlementModalOverlayClass,
  settlementModalPanelClass,
  settlementModalPanelCompactClass,
  settlementModalPanelWideClass,
} from './uiClasses.js';

const compactWidth = {
  sm: 'sm:max-w-md',
  md: 'sm:max-w-lg',
};

/**
 * Settlement/review dialog: sheet on mobile, large panel on iPad/desktop.
 * size sm/md: compact content-hugging panel. xl: wide tables. fillHeight: two-column review.
 */
export default function SettlementModalShell({
  title,
  subtitle,
  onClose,
  children,
  footer,
  headerActions = null,
  fillHeight = false,
  size = 'lg',
  zIndex,
}) {
  const compact = size === 'sm' || size === 'md';
  const panelClass = compact
    ? `${settlementModalPanelCompactClass} ${compactWidth[size]}`
    : (size === 'xl' ? settlementModalPanelWideClass : settlementModalPanelClass);
  const bodyClass = size === 'sm'
    ? settlementModalBodyCompactClass
    : (fillHeight ? settlementModalBodyFillClass : settlementModalBodyClass);

  return (
    <div
      className={settlementModalOverlayClass}
      style={zIndex != null ? { zIndex } : undefined}
      onClick={onClose}
    >
      <div
        className={panelClass}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="settlement-modal-title"
      >
        <div className={settlementModalHeaderClass}>
          <div className="min-w-0">
            <h3 id="settlement-modal-title" className="text-base sm:text-lg font-semibold text-sky-950">
              {title}
            </h3>
            {subtitle ? (
              <p className="text-xs text-sky-800/80 mt-0.5 truncate" title={subtitle}>{subtitle}</p>
            ) : null}
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2 shrink-0">
            {headerActions}
            <button
              type="button"
              onClick={onClose}
              className="p-1.5 rounded-lg hover:bg-sky-100 shrink-0"
              aria-label="Close"
            >
              <X className="w-5 h-5 text-sky-700" />
            </button>
          </div>
        </div>
        <div className={bodyClass}>
          {children}
        </div>
        {footer ? (
          <div className="shrink-0 px-3 sm:px-5 py-2.5 border-t border-sky-100 bg-sky-50/50">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}
